import config from "@/utils/config";
import {handleUrlEncode} from "@/utils/urlutil";
import request from "@/utils/request";

/**
 * 后台添加设备问题
 * @param {Object} params
 */
export function addAdminQuestion(params) {
    return request({
        url: config.API_ADMIN + "/Api/V1/AdminQuestion/Question/Add",
        method: "post",
        data: params,
    });
}

/**
 * 后台删除或者恢复指定设备问题
 * @param {Object} params
 */
export function deleteAdminQuestionOrBack(params) {
    return request({
        url: config.API_ADMIN + "/Api/V1/AdminQuestion/Question/DeleteOrBack",
        method: "delete",
        params,
    });
}

/**
 * 后台分页获取设备客服问题集合
 * @param {Object} params
 */
export function getAdminQuestionList(params) {
    let url = config.API_ADMIN + "/Api/V1/AdminQuestion/Question/List?"
    url = handleUrlEncode(url,params)
    return request({
        url: url,
        method: "get",
    });
}

/**
 * 后台获取指定设备客服问题详情
 * @param {Object} params
 */
export function getAdminQuestionOne(params) {
    return request({
        url: config.API_ADMIN + "/Api/V1/AdminQuestion/Question/One",
        method: "get",
        params,
    });
}

/**
 * 后台更新设备问题
 * @param {Object} params
 */
export function updateAdminQuestion(params) {
    return request({
        url: config.API_ADMIN + "/Api/V1/AdminQuestion/Question/Update",
        method: "post",
        data: params,
    });
}

/**
 * 后台添加设备客服问题文件
 * @param {Object} params
 */
export function addAdminQuestionFile(params) {
    return request({
        url: config.API_ADMIN + "/Api/V1/AdminQuestion/QuestionFile/Add",
        method: "post",
        data: params,
    });
}

/**
 * 后台删除或者恢复指定设备问题文件
 * @param {Object} params
 */
export function deleteAdminQuestionFileOrBack(params) {
    return request({
        url: config.API_ADMIN + "/Api/V1/AdminQuestion/QuestionFile/DeleteOrBack",
        method: "delete",
        params: params,
    });
}